import { del, get, patch, post, put } from "./api_helper";
import * as url from "./url_helper";

export const getLogging = (data) => post(url.LOGIN, data);
export const forgot = (data) => post(url.FORGOT, data);
export const verifyToken = (token) => get(url.VERIFY_TOKEN + token);
export const resetPassword = (token, data) => {
  return post(url.RESET + token, data);
};
export const getProfile = () => get(url.GET_PROFILE);
export const updateProfile = (data) => post(url.UPDATE_PROFILE, data);
export const changePassword = (data) => post(url.CHANGE_PROFILE, data);
export const updateBank = (data) => post(url.UPDATE_BANK, data);
export const getBank = () => get(url.GET_BANK);



export const getNotificationTemplates = () => get(url.GET_NOTIFICATION_TEMPLATES);
export const updateNotificationTemplate = (id, data) => put(url.UPDATE_NOTIFICATION_TEMPLATE + id, data);

//
export const getCity = (id) => get(url.CITY + id);
export const updateCity = (data, id) => put(url.CITY_UPDATE + id, data);
export const changeCityStatus = (data) => post(url.CITY_STATUS, data);
export const addCity = (data) => post(url.CITY_ADD, data);
export const getCities = (filters) => get(url.CITY_LIST, filters);
export const getCitiesList = (filters) => get(url.GET_CITY_LIST, filters);

//dashboard
export const getDashboardCount = (filter) => get(url.TOTAL_COUNT, filter);
export const getLeaderboardData = (filters) =>
  get(url.LEADERBOARD_DATA, filters);

//booking
export const ListAttendance = (filter) => get(url.ATTENDANCE_LIST, filter);
export const ListBooking = (filter) => get(url.BOOKING_LIST, filter);
export const UpdateBooking = (data, id) => put(url.BOOKING_STATUS + id, data);
export const classReservations = (filter) => get(url.CLASS_RESERVATIONS, filter);
export const cancelClass = (filter) => get(url.CANCEL_BOOKING, filter);

//customer
export const addCustomer = (data) => post(url.CUSTOMER, data);
export const ListCustomer = (filter) => get(url.CUSTOMER_LIST, filter);
export const ViewStudents = (id) => get(url.STUDENT_LIST + id);
export const updateCustomer = (data, id) => put(url.CUSTOMER_UPDATE + id, data);
export const StatusChangeCustomer = (id, data) =>
  put(url.CUSTOMER_STATUS + id, data);
export const getCustomer = (id) => get(url.CUSTOMER_UPDATE + id);
export const deleteCustomer = (id) => del(url.CUSTOMER_UPDATE + id);
export const customerStats = (id) => get(url.CUSTOMER_STATS + id);

//graduation
export const createGraduation = (data) => post(url.GRADUATION, data);
export const listGraduations = (filter) => get(url.GRADUATION_LIST, filter);
export const deleteGraduation = (id) => del(url.GRADUATION_DELETE + id);

//exam
export const createExam = (data) => post(url.EXAM, data);
export const listExam = (filter) => get(url.EXAM_LIST, filter);
export const listEligibles = (id, filter) => get(url.ELIGIBLE_LIST + id, filter);
export const allEligibles = (params) => get(url.ALL_ELIGIBLE, params);
export const updateEligibleNote = (data) => patch(url.UPDATE_ELIGIBLE_NOTE, data);
export const updateExam = (data, id) => put(url.EXAM_UPDATE + id, data);
export const deleteExam = (id) => put(url.EXAM_DELETE + id);


//Result/Graduation
export const addResult = (data) => post(url.RESULT, data);
export const listResult = (filter) => get(url.RESULT_LIST, filter);

//Student Progress
export const grantKyu = (data) => patch(url.GRANT_KYU, data);
export const listProgress = (filter) => get(url.LIST_PROGRESS, filter);
export const viewProgress = (id) => get(url.VIEW_PROGRESS + id);

//branch
export const addBranch = (data) => post(url.BRANCH, data);
export const ListBranch = (filter) => get(url.BRANCH_LIST, filter);
export const updateBranch = (data, id) => put(url.BRANCH_UPDATE + id, data);
export const StatusChangeBranch = (id, data) =>
  put(url.BRANCH_STATUS + id, data);
export const StatusChangeBranchAccess = (id, data) =>
  put(url.BRANCH_ACCESS_STATUS + id, data);
export const getBranch = (id) => get(url.BRANCH_UPDATE + id);
export const deleteBranch = (id, data) => put(url.BRANCH_DELETE + id, data);
// export const branchStats = (id) => get(url.BRANCH_INFO + id);
export const branchStats = (id, params = {}) => {
  const query = new URLSearchParams(params).toString();
  return get(`${url.BRANCH_INFO}${id}?${query}`);
};

//employee
export const addEmployee = (data) => post(url.EMPLOYEE, data);
export const ListEmployee = (filter) => get(url.EMPLOYEE_LIST, filter);
export const ListEmployeeAndBranchAdmin = (filter) => get(url.EMPLOYEE_AND_BRANCH_ADMIN_LIST, filter);
export const updateEmployee = (data, id) => put(url.EMPLOYEE_UPDATE + id, data);
export const StatusChangeEmployee = (id, data) =>
  put(url.EMPLOYEE_STATUS + id, data);
export const deleteEmployee = (id, data) => put(url.EMPLOYEE_DELETE + id, data);
export const getEmployee = (id) => get(url.EMPLOYEE_UPDATE + id);

// class
export const addClass = (data) => post(url.CLASS, data);
export const ListClass = (filter) => get(url.CLASS_LIST, filter);
export const ListClasses = (filter) => get(url.LIST_CLASSES, filter);
export const updateClass = (data, id) => put(url.CLASS_UPDATE + id, data);
export const StatusChangeClass = (id, data) => put(url.CLASS_STATUS + id, data);
export const deleteClass = (id, data) => put(url.CLASS_DELETE + id, data);
export const getClass = (id) => get(url.CLASS_UPDATE + id);
export const getClassSlots = (data) => post(url.CLASS_SLOTS, data);
export const updateClassSlot = (data) => post(url.UPDATE_SLOT, data);

//transaction
export const addTransaction = (data) => post(url.TRANSACTION, data);
export const ListTransaction = (filter) => get(url.TRANSACTION_LIST, filter);
export const transactionGraph = (filter) => get(url.TRANSACTION_GRAPH, filter);

//banner
export const addBanner = (data) => post(url.BANNER, data);
export const editBanner = (data, id) => put(url.BANNER_UPDATE + id, data);
export const listBanner = (filters) => get(url.BANNER_LIST, filters);
export const deleteBanner = (id, data) => put(url.BANNER_DELETE + id, data);
export const getBanner = (id) => get(url.BANNER_UPDATE + id);

// Report
export const ListReport = (filter) => get(url.REPORT_LIST, filter);
export const getReportById = (id) => get(url.REPORT_UPDATE + id);
export const updateReport = (data, id) => put(url.REPORT_UPDATE + id, data);
export const replyReport = (data) => post(url.REPORT_REPLY, data);

// subscription
export const addSubscription = (data) => post(url.SUBSCRIPTION, data);
export const ListSubscription = (filter) => get(url.SUBSCRIPTION_LIST, filter);
export const updateSubscription = (data, id) =>
  put(url.SUBSCRIPTION_UPDATE + id, data);
export const StatusChangeSubscription = (id, data) =>
  put(url.SUBSCRIPTION_STATUS + id, data);
export const deleteSubscription = (id) => del(url.SUBSCRIPTION_DELETE + id);
export const getSubscription = (id) => get(url.SUBSCRIPTION_UPDATE + id);

//subscription request
export const ListSubscriptionRequest = (filter) =>
  get(url.SUBSCRIPTION_REQUEST_LIST, filter);
export const getSubscriptionRequest = (id) =>
  get(url.SUBSCRIPTION_REQUEST_UPDATE + id);
export const updateSubscriptionRequest = (data, id) =>
  put(url.SUBSCRIPTION_REQUEST_UPDATE + id, data);
export const acceptSubscriptionRequest = (id) =>
  put(url.SUBSCRIPTION_REQUEST_ACCEPT + id);
export const rejectSubscriptionRequest = (id) =>
  put(url.SUBSCRIPTION_REQUEST_REJECT + id);

// belt
export const addBelt = (data) => post(url.BELT, data);
export const ListBelt = (filter) => get(url.BELT_LIST, filter);
export const BranchListBelt = (filter) => get(url.BRANCH_BELT_LIST, filter);
export const updateBelt = (data, id) => put(url.BELT_UPDATE + id, data);
export const StatusChangeBelt = (id, data) => put(url.BELT_STATUS + id, data);
export const deleteBelt = (id) => put(url.BELT_DELETE + id);
export const getBelt = (id) => get(url.BELT_UPDATE + id);

// kyu
export const addKyu = (data) => post(url.KYU, data);
export const ListKyu = (filter) => get(url.KYU_LIST, filter);
export const updateKyu = (data, id) => put(url.KYU_UPDATE + id, data);
export const StatusChangeKyu = (id, data) => patch(url.KYU_STATUS + id, data);
export const deleteKyu = (id) => patch(url.KYU_DELETE + id);
export const getKyu = (id) => get(url.KYU_UPDATE + id);
export const GetKyuByBelt = ({ beltId }) => get(url.GET_KYU_BY_BELT + beltId);

//tutor
export const addTutor = (data) => post(url.TUTOR, data);
export const addTutorChat = (data) => post(url.TUTOR_CHAT, data);
export const ListTutor = (filter) => get(url.TUTOR_LIST, filter);
export const deleteTutor = (id) => del(url.TUTOR_DELETE + id);
export const updateTutor = (data, id) => put(url.TUTOR_UPDATE + id, data);
export const StatusChangeTutor = (id, data) => put(url.TUTOR_STATUS + id, data);
export const getTutor = (id) => get(url.TUTOR_UPDATE + id);
export const getTutorByCourse = (id) => get(url.TUTOR_BY_COURSE + id);
export const getTutorByID = (id) =>
  get(url.TUTOR_UPDATE + "by-email-or-id", id);
export const tutorWalletUpdate = (data, id) =>
  post(url.TUTOR_WALLET_UPDATE + id, data);
export const getTutorReview = (id) => get(url.TUTOR_REVIEW + id);
export const deleteTutorDelReview = (id) => del(url.TUTOR_REVIEW + id);

//role
export const addRole = (data) => post(url.ROLE, data);
export const ListRole = (filter) => get(url.ROLE_LIST, filter);
export const updateRole = (data, id) => put(url.ROLE_UPDATE + id, data);
export const StatusChangeRole = (id, data) => put(url.ROLE_STATUS + id, data);
export const getRole = (id) => get(url.ROLE_UPDATE + id);
export const deleteRole = (id) => del(url.ROLE_DELETE + id);

//rmail
export const ListEmail = (filter) => get(url.EMAIL_LIST, filter);
export const updateEmail = (data, id) => put(url.EMAIL_UPDATE + id, data);
export const StatusChangeEmail = (id, data) => put(url.EMAIL_STATUS + id, data);
export const getEmail = (id) => get(url.EMAIL_UPDATE + id);

//notification
export const ListNotification = (filter) => get(url.NOTIFICATION_LIST, filter);
export const getNotification = (id) => get(url.NOTIFICATION_UPDATE + id);
export const addNotification = (data) => post(url.NOTIFICATION, data);
export const deleteNotification = (id) => del(url.NOTIFICATION_DELETE + id);
export const adminNotification = (filter) =>
  get(url.NOTIFICATION_ADMIN, filter);

//course
export const ListCourse = (filter) => get(url.COURSE_LIST, filter);
export const getCourse = (id) => get(url.COURSE_UPDATE + id);
export const addCourse = (data) => post(url.COURSE, data);
export const updateCourse = (data, id) => put(url.COURSE_UPDATE + id, data);
export const updateTrending = (data, id) => put(url.COURSE_TRENDING + id, data);
export const StatusChangeCourse = (id, data) =>
  put(url.COURSE_STATUS + id, data);
export const deleteCourse = (id) => del(url.COURSE_DELETE + id);

//content
export const ListContent = (filter) => get(url.CONTENT_LIST, filter);
export const getContent = (id) => get(url.CONTENT_UPDATE + id);
export const addContent = (data) => post(url.CONTENT, data);
export const updateContent = (data, id) => put(url.CONTENT_UPDATE + id, data);
export const deleteContent = (id) => del(url.CONTENT_DELETE + id);

//event
export const ListEvent = (filter) => get(url.EVENT_LIST, filter);
export const getEvent = (id) => get(url.EVENT_UPDATE + id);
export const addEvent = (data) => post(url.EVENT, data);
export const updateEvent = (data, id) => put(url.EVENT_UPDATE + id, data);
export const deleteEvent = (id) => del(url.EVENT_DELETE + id);

// Common
export const getKyus = (filter) => get(url.GET_KYUS, filter);
export const getBelts = (filter) => get(url.GET_BELTS, filter);
export const getAllBelt = (filter) => get(url.GET_All_BELT, filter);
export const getTrainers = (filter) => get(url.GET_TRAINERS, filter);
export const getEmployees = (filter) => get(url.GET_EMPLOYEES, filter);
export const getStudents = (filter) => get(url.GET_STUDENTS, filter);
export const getStudent = (filter) => get(url.GET_STUDENT, filter);
export const getClasses = (filter) => get(url.GET_CLASSES, filter);
export const getBranches = (filter) => get(url.GET_BRANCHES, filter);
